export const data = {
    name: "Casing",
    layout: [],
};
export default data;